(function(angular, schoolwork12) {
    'use strict';
    angular.module(schoolwork12.app.manageCourseManagement.name)
        .factory(schoolwork12.app.manageCourseManagement.services.courseManagementService, ['$http', '$q', function ($http, $q) {
    
                var getCourseManagementSearchFilters = function (keycode) {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'GET',
                        url: schoolwork12.app.manageCourseManagement.endpoints.courseFilter,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        }
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {  
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };

                var getCourseDropDownDetails = function (keycode) {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'GET',
                        url: schoolwork12.app.manageCourseManagement.endpoints.courseDropDownDetails,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        }
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {  
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };
                
                var getCourseByCode = function (keycode, courseCode) {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'GET',
                        url: schoolwork12.app.manageCourseManagement.endpoints.courseByCode + courseCode,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        }
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {  
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };

                var nextCourseListByCode = function (keycode, courseCode) {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'GET',
                        url: schoolwork12.app.manageCourseManagement.endpoints.nextCourseListByCode + courseCode,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        }
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {  
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };

                const addCourse = (keycode, course) => {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'POST',
                        url: schoolwork12.app.manageCourseManagement.endpoints.addCourse,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        },
                        data: course
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };

                const editCourse = (keycode, course) => {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'PUT',
                        url: schoolwork12.app.manageCourseManagement.endpoints.addCourse,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        },
                        data: course
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };


                const searchCourses = (keycode, filters) => {
                    var deferred = $q.defer();
                    var request = $http({
                        method: 'POST',
                        url: schoolwork12.app.manageCourseManagement.endpoints.searchCourses,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-TOKEN': keycode
                        },
                        data: filters
                    });
                    request.then(function (response) {
                        deferred.resolve(response.data);
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                };

            const reactivateCourses = (keycode, courses) => {
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.manageCourseManagement.endpoints.reactivateCourses,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: courses
                });
                request.then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            const deactivateCourses = (keycode, courses) => {
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.manageCourseManagement.endpoints.deactivateCourses,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: courses
                });
                request.then(function (response) {
                    deferred.resolve(response.data);
                }, function (error) {
                    deferred.reject(error);
                });
                return deferred.promise;
            };

                return {
                    addCourse: addCourse,
                    editCourse: editCourse,
                    getCourseManagementSearchFilters: getCourseManagementSearchFilters,
                    getCourseDropDownDetails: getCourseDropDownDetails,
                    getCourseByCode: getCourseByCode,
                    nextCourseListByCode: nextCourseListByCode,
                    searchCourses: searchCourses,
                    reactivateCourses: reactivateCourses,
                    deactivateCourses: deactivateCourses
                };
            }
    
        ]);
    }(angular, schoolwork12));
